// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2QNd6","selected":"Chip_selected__XheP0"};